<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listSector"
        :title-table="$t('Sector')"
        module="sectorSettingsModule"
        sort-name="nome"
        add-permission="ROLE_SETOR_INSERIR"
        view-permission="ROLE_SETOR_CONSULTAR"
        edit-permission="ROLE_SETOR_ATUALIZAR"
        delete-permission="ROLE_SETOR_DELETAR"
        @add="addNew"
        @edit="edit"
      />
      <FormSector
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import FormSector from './forms/FormSector.vue'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormSector,
  },
  computed: {
    ...mapState('sectorSettingsModule', {
      listSector: state => state.listSector,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'Descrição',
          field: 'nome',
        },
        {
          label: 'Ativo',
          field: 'ativo',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch('sectorSettingsModule/prepareToEditSector', data)
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
